import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'es6-promise/auto';
import 'fetch-polyfill';

import VueCompositionAPI from '@vue/composition-api';
import { Logger } from 'aws-amplify';
import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import { i18n } from './plugins/i18n/i18n';
import PermissionPlugin from './plugins/permission';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
import '@mdi/font/css/materialdesignicons.min.css';

Vue.use(PermissionPlugin);
Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;

// Importing the global css files
import '@/assets/css/general.css';
import '@/assets/css/theme-dark.css';

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');

/* Unexpected warn message is displayed due to the current vuetify version.
   If upgrade the vuetify version(>=2.3.14), the other problems will be occurred.
   Currently, take the following solutuon to ignore the warn message.
   TODO: http://product-ci.works-hi/company/hr-portal/-/issues/608
*/
const logger = new Logger('Vue warn');
const ignoredMessage =
  'The .native modifier for v-on is only valid on components but it was used on <div>.';

Vue.config.warnHandler = (message, _vm, componentTrace) => {
  if (message !== ignoredMessage) {
    logger.error(message + componentTrace);
  }
};
